import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout';
import Card from '../../components/Card';
import Button from '../../components/Button';
import Table from '../../components/Table';
import api from '../../services/api';
import '../../styles/components.css';

const AdminDashboard = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [stats, setStats] = useState({});
    const [recentActivities, setRecentActivities] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const [statsRes, activitiesRes] = await Promise.all([
                api.get('/admin/stats'),
                api.get('/admin/recent-activities')
            ]);

            setStats(statsRes.data.stats || {});
            setRecentActivities(activitiesRes.data.activities || []);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    const activityColumns = [
        { header: 'Action', field: 'action' },
        { header: 'User', field: 'user_name' },
        { header: 'Details', field: 'details', width: '40%' },
        { header: 'Time', render: (row) => new Date(row.created_at).toLocaleString() }
    ];

    if (loading) {
        return <Layout title="Admin Dashboard"><div className="loading">Loading...</div></Layout>;
    }

    return (
        <Layout title="Admin Dashboard">
            <div className="stats-grid">
                <div className="stat-card info">
                    <div className="stat-label" style={{color: 'black' }}><b>Active Scholars</b></div>
                    <div className="stat-value">{stats.active_scholars || 0}</div>
                </div>
                <div className="stat-card info">
                    <div className="stat-label" style={{color: 'black' }}>
  <b>Completed</b>
</div>
                    <div className="stat-value">{stats.completed_scholars || 0}</div>
                </div>
                <div className="stat-card info">
                    <div className="stat-label" style={{color: 'black' }}><b>Suspended</b></div>
                    <div className="stat-value">{stats.suspended_scholars || 0}</div>
                </div>
                <div className="stat-card info">
                    <div className="stat-label" style={{color: 'black' }}><b>Terminated</b></div>
                    <div className="stat-value">{stats.terminated_scholars || 0}</div>
                </div>
                <div className="stat-card info">
                    <div className="stat-label" style={{color: 'black' }}><b>Relived</b></div>
                    <div className="stat-value">{stats.relived_scholars || 0}</div>
                </div>
                <div className="stat-card info">
                    <div className="stat-label" style={{color: 'black' }}><b>Left</b></div>
                    <div className="stat-value">{stats.left_scholars || 0}</div>
                </div>
                <div className="stat-card info">
                    <div className="stat-label" style={{color: 'black' }}><b>Total Publications</b></div>
                    <div className="stat-value">{stats.total_publications || 0}</div>
                </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', marginBottom: '2rem' }}>
                <Button variant="primary" onClick={() => navigate('/admin/enroll')}>
                    Enroll New Scholar
                </Button>
                <Button variant="primary" onClick={() => navigate('/admin/enroll-staff')}>
                    Enroll Staff (Supervisor / DLC / HOD)
                </Button>
                <Button variant="primary" onClick={() => navigate('/admin/users')}>
                    Manage Users
                </Button>
            </div>

            <Card title="Recent System Activities">
                <Table
                    columns={activityColumns}
                    data={recentActivities}
                    emptyMessage="No recent activities"
                />
            </Card>
        </Layout>
    );
};

export default AdminDashboard;
